export default __webpack_public_path__ + "static/media/NO28_NFT002M.798251d6.mp4";